import { css, type Theme } from "@emotion/react";

/* Darkens every slide's photo or video backdrop so the inverse-intention text stays legible. */
export const SLIDE_SCRIM_COLOR = "rgba(30, 30, 30, 0.4)";

export const panel = css`
  position: relative;
  height: 100%;
`;

/* Taking the carousel out of flow keeps the stacked slides from summing into the
   panel's intrinsic height, which would stretch the whole sign-in row past the viewport. */
export const viewport = css`
  position: absolute;
  inset: 0;
  overflow: hidden;
  user-select: none;
`;

/* A vertical embla carousel needs a column flex track where every slide
   matches the viewport height, otherwise snap points drift. */
export const slideColumn = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const slideItem = css`
  display: flex;
  flex: 0 0 100%;
  min-height: 0;

  > * {
    flex: 1;
  }
`;

export const navOverlay = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  right: ${theme.ds5.spacing.gap.large};
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
`;

/* Clears the floating dot navigation: its gap.large right offset plus the 36px
   play/pause button, with the same offset again as breathing room. Mirrored on
   the left so slide content stays centered on narrow panels. */
export const slideContentInset = (theme: Theme) => css`
  padding-right: calc(2 * ${theme.ds5.spacing.gap.large} + 36px);
  padding-left: calc(2 * ${theme.ds5.spacing.gap.large} + 36px);
`;
